import {Component, EventEmitter, OnInit} from '@angular/core';
import {NbWindowService} from '@nebular/theme';
import {takeUntil} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {BaseFieldType} from 'compob2b-libs';
import {FeatureMapperComponent} from './modals/feature-mapper/feature-mapper.component';

@Component({
    selector: 'app-template-mapper',
    templateUrl: './template-mapper.component.html',
    standalone: false
})
export class TemplateMapperComponent extends BaseFieldType implements OnInit {
  updateTemplateMapping = new EventEmitter<boolean>();

  constructor(private readonly windowService: NbWindowService) {
    super();
  }

  ngOnInit(): void {
    this.updateTemplateMapping.pipe(takeUntil(this.unsubscribe)).subscribe(_ => this.cdr.detectChanges());
  }

  defineTemplateMapping() {
    const {templateId, newTemplateId} = this.model;
    if (this.form.get('templateId').invalid || this.form.get('newTemplateId').invalid) {
      this.errorToast(translations.templateDefinitionError);
      return;
    }

    const data = {
      sourceTemplateId: parseInt(templateId, 10),
      destTemplateId: parseInt(newTemplateId, 10),
      updateTemplateMapping: this.updateTemplateMapping,
      formControl: this.formControl,
    };

    this.windowService.open(FeatureMapperComponent, {
      title: translations.templateFeatureMapping,
      windowClass: 'col-sm-10',
      context: data,
    });
  }

}
